import TRAVEL_DESTINATION_COUNTRIES from './travelDestinationCountries';
import { REGION_AFRICA, REGION_ASIA, REGION_EUROPE } from './travelProducts';

/**
 * Pacis TRC_TRZ_CODE → Mapfre CMBDESTINOSV.
 * Pacis 2 is Asia; Mapfre 2 is Europe. Sending the Pacis code as-is fails issue.
 */
export const PACIS_ZONE_TO_MAPFRE_DESTINATION = {
  1: '1',
  2: '12',
  3: '3',
  4: '2',
};

export function findDestinationCountry(code) {
  if (!code) return null;
  const normalized = String(code).trim().toUpperCase();
  return TRAVEL_DESTINATION_COUNTRIES.find((c) => c.TRC_SHT_DESC === normalized) || null;
}

/** Mapfre destination that owns this ISO country (required for issue). */
export function getMapfreDestinationZone(countryCode, fallbackZone) {
  const country = findDestinationCountry(countryCode);
  if (country) {
    return PACIS_ZONE_TO_MAPFRE_DESTINATION[country.TRC_TRZ_CODE]
      || String(country.TRC_TRZ_CODE);
  }
  if (fallbackZone != null && String(fallbackZone).trim() !== '') {
    return String(fallbackZone);
  }
  return '1';
}

/**
 * Filter destination countries by travel region (Pacis product region).
 * Worldwide Mapfre products only allow dest 3 (Americas / Oceania). Listing
 * Europe here is what let agents issue WW_IND_PRE + DE, which Mapfre rejects.
 */
export function getCountriesForRegion(region) {
  if (!region) return TRAVEL_DESTINATION_COUNTRIES;

  let zoneCode;
  switch (region) {
    case REGION_AFRICA:
      zoneCode = 1;
      break;
    case REGION_ASIA:
      zoneCode = 2;
      break;
    case REGION_EUROPE:
      zoneCode = 4;
      break;
    case 'Worldwide Basic':
    case 'Worldwide Premium':
    case 'Worldwide Extra':
    case 'Worldwide Classic':
      zoneCode = 3;
      break;
    default:
      return TRAVEL_DESTINATION_COUNTRIES;
  }

  return TRAVEL_DESTINATION_COUNTRIES.filter((c) => c.TRC_TRZ_CODE === zoneCode);
}

export function formatCountryOption(country) {
  return {
    code: country.TRC_SHT_DESC,
    label: `${country.TRC_NAME} (${country.TRC_SHT_DESC})`,
    zone: country.TRC_TRZ_CODE,
  };
}
